'use strict'

module.exports = {
  SHA1: 20,
  SHA256: 32,
  SHA512: 64
}
